var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-view"},[_c('h5',[_c('feather-icon',{staticClass:"mr-1",attrs:{"icon":"AlertTriangleIcon","svgClasses":"h-5 w-5"}}),_vm._v("유의사항")],1),_c('div',{staticClass:"body"},_vm._l((_vm.list),function(item){return _c('p',[_c('i',{staticClass:"dot"}),_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }